import firebase from '../firebase-config'
var fluxersRef = firebase.db.ref('fluxers')

export default {

  getCurrentUser () {
    let keyAuth = Object.keys(localStorage)[0]
    if (!keyAuth) {
      return false
    }
    let user = JSON.parse(localStorage[keyAuth])
    return user
  },
  getFluxerByEmail (userEmail) {
    return fluxersRef.orderByChild('email').equalTo(userEmail)
  },
  getAll () {
    return fluxersRef.orderByChild('displayName')
  },
  getLideres () {
    return fluxersRef.orderByChild('lider').equalTo(true)
  },
  addUser (user) {
    fluxersRef.child(user.providerData[0].uid).once('value', (snapshot) => {
      let exist = snapshot.val()
      if (!exist) {
        let userAdd = {}
        userAdd['displayName'] = user.providerData[0].displayName
        userAdd['email'] = user.providerData[0].email
        userAdd['photoURL'] = user.providerData[0].photoURL
        fluxersRef.child(user.providerData[0].uid).set(userAdd)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/fluxer.js